export interface LocalRxdbProperties {
	rxdbid?: number;
	rxdbidstring?: string;
	isDeleted?: boolean;
}
